import React, { Component } from 'react';
import styled from 'styled-components';
import { I18n } from 'react-redux-i18n';

import NoteFilters from 'modules/Notes/components/AllNotes/FiltersFields';
import SearchMultipleFields from 'components/SearchMultipleFields';

const Container = styled.div`
  background-color: ${(props) => props.theme.colors['white']};
  padding: 20px;
  border-radius: 4px;
  margin-bottom: 20px;

  @media (max-width: 845px) {
    padding: 16px;
  }

  > *:not(:last-child) {
    margin-bottom: 20px;
  }
`;

const createOption = (value) => (value ? { label: value, value } : null);

class FilterBloc extends Component {
  constructor(props) {
    super(props);
    this.state = {
      wine: '',
      journal: '',
      taster: '',
      vintages: '',
      type: '',
      placeholder: ''
    };
  }

  render() {
    const { options, values, onChange, optionsSearch } = this.props;
    return (
      <Container marginBottom={this.props.marginBottom}>
        <SearchMultipleFields
          minOpen={1}
          options={optionsSearch}
          value={values.optionSearch}
          onChange={(value) => onChange('optionSearch', value)}
          placeholder={I18n.t('notes.allNotes.filters.searchPlaceholder')}
        />
        <NoteFilters
          wineFilter={{
            selectedOption: createOption(values.wine),
            options: options.wine,
            onChange: (value) => onChange('wine', value),
            label: I18n.t('notes.allNotes.filters.wine'),
            placeholder: I18n.t('placeholderAll')
          }}
          vintagesFilter={{
            selectedOption: createOption(values.vintage),
            options: options.vintage,
            onChange: (value) => onChange('vintage', value),
            label: I18n.t('notes.allNotes.filters.vintage'),
            placeholder: I18n.t('placeholderAll')
          }}
          journalFilter={{
            selectedOption: createOption(values.journal),
            options: options.journal,
            onChange: (value) => onChange('journal', value),
            label: I18n.t('notes.allNotes.filters.journal'),
            placeholder: I18n.t('placeholderAll')
          }}
          tasterFilter={{
            selectedOption: createOption(values.degustateur),
            options: options.degustateur,
            onChange: (value) => onChange('degustateur', value),
            label: I18n.t('notes.allNotes.filters.journalist'),
            placeholder: I18n.t('placeholderAll')
          }}
          typeFilter={{
            selectedOption: createOption(values.type),
            options: options.type,
            onChange: (value) => onChange('type', value),
            label: I18n.t('notes.allNotes.filters.type'),
            placeholder: I18n.t('placeholderAll')
          }}
          hasWxrPanel={this.props.hasWxrPanel}
        />
      </Container>
    );
  }
}

export default FilterBloc;
